import { CheckboxOptionType, RadioChangeEvent } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import { SkillResponse } from "../../../../hooks/Skills/data";
import { useGetSkills } from "../../../../hooks/Skills/skills.hooks";
import { useCoachesContext } from "../../context/CoachesContext";
import styles from "./style.module.scss";
import "./styles.scss";

const SkillsFilter = () => {
  const { t } = useTranslation();
  const { value, setValue } = useCoachesContext();
  const [options, setOptions] = useState<
    (string | number | CheckboxOptionType<any>)[]
  >([]);

  const { data: skills, isLoading: loadingSkills } = useGetSkills({});

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (!skills) return;
    setOptions(
      skills?.map((skill: SkillResponse) => {
        return {
          label: t(`normal.skill.${skill.skill_code}`),
          value: skill.skill_code,
        };
      })
    );
  }, [skills]);

  return (
    <CustomRadioButton
      wrapperStyle={styles.radioWrapper}
      items={options}
      onValueChange={onChange}
      selectedValue={value}
      loading={loadingSkills}
      centered={true}
    />
  );
};

export default SkillsFilter;
